import { jsonldAddressCountry } from './JsonldStore';

export const updateJsonldAddressCountry = (value) => jsonldAddressCountry.update((oldValue) => value);
